import { IntlTFunc } from 'next-intl';

import BoxIcon from '@/fo/icons/base/icons/box.svg';
import HandbagIcon from '@/fo/icons/base/icons/handbag.svg';
/*import HelpIcon from '@/fo/icons/base/icons/help.svg';*/
import SecretIcon from '@/fo/icons/base/icons/secret.svg';

import diagnosticsImage from './assets/diagnostics.webp';
import diamondImage from './assets/diamond.webp';
import giftsIcon from './assets/gifts.webp';
import handbagImage from './assets/handbag.webp';
import heartImage from './assets/heart.webp';
import pointsIcon from './assets/points.webp';
import secretSalesIcon from './assets/secret-sales.webp';

export const benefitsMock = (t: IntlTFunc) => ({
  benefits: [
    {
      description: t('article.page.loyalty.benefits.points'),
      icon: pointsIcon
    },
    {
      description: t('article.page.loyalty.benefits.secretSales'),
      icon: secretSalesIcon
    },
    {
      description: t('article.page.loyalty.benefits.gifts'),
      icon: giftsIcon
    }
  ]
});

export const levelsMock = (
  onClick: () => void,
  onTypeSkinClick: () => void
) => ({
  levels: [
    {
      description:
        'Привилегии этапа сохраняются до перехода на следующий уровень',
      cashbackPoints: 10,
      privileges: [
        {
          description: 'Доступ к новинкам и секретным распродажам',
          icon: (
            <SecretIcon
              width={24}
              height={24}
            />
          )
        },
        {
          description: '15% скидка и кешбэк на первую покупку',
          icon: (
            <HandbagIcon
              width={24}
              height={24}
            />
          )
        }
      ],
      steps: [
        <>
          <button
            type="button"
            className="link underline underline-offset-4"
            onClick={onClick}
          >
            Зарегистрируйтесь
          </button>{' '}
          в Программе привилегий NAOS
        </>,
        'Подтвердите email, чтобы получать информацию о новинках и закрытых активностях раньше остальных'
      ]
    },
    {
      description: 'Уровень сохраняется на 180 дней после последней покупки',
      cashbackPoints: 25,
      privileges: [
        {
          description: 'Доступ к новинкам и секретным распродажам',
          icon: (
            <SecretIcon
              width={24}
              height={24}
            />
          )
        },
        {
          description: 'Дополнительные подарки к заказу',
          icon: (
            <BoxIcon
              width={24}
              height={24}
            />
          )
        }
        /*{
          description: 'Бесплатная консультация дерматолога',
          icon: (
            <HelpIcon
              width={24}
              height={24}
            />
          )
        }*/
      ],
      steps: [
        'Совершите заказы на общую сумму от 5 000 ₽ в течение 6 месяцев',
        <>
          Заполните все поля{' '}
          <button
            type="button"
            className="link underline underline-offset-4"
            onClick={onTypeSkinClick}
          >
            Анкеты пользователя
          </button>{' '}
          о вашей коже в личном кабинете
        </>
      ]
    }
  ]
});

export const pointsMock = (
  onClickPrivate: () => void,
  onClickLoyaltyProducts: () => void
) => ({
  description: (
    <>
      Программа привилегий NAOS даёт дополнительные возможности накапливать
      баллы. Приглашайте друзей присоединиться к программе и получайте баллы
      за их первый заказ, а также подписывайтесь на email-рассылку,
      чтобы первыми узнавать о продуктах с повышенным кешбэком баллами.
    </>
  ),
  points: [
    {
      description: 'Пригласите друга',
      icon: heartImage,
      onClick: onClickPrivate
    },
    {
      description: 'Возвращайтесь за покупками чаще',
      icon: handbagImage,
      href: '/catalog/'
    },
    {
      description: 'Следите за товарами с повышенным кешбэком',
      icon: diamondImage,
      onClick: onClickLoyaltyProducts
    },
    {
      description: 'Пройдите диагностику',
      icon: diagnosticsImage,
      variant: 'soon'
    }
  ]
});
